/*
 * @Author: qeg ljl1997haha@163.com
 * @Date: 2024-05-31 10:49:47
 * @LastEditors: qeg ljl1997haha@163.com
 * @LastEditTime: 2024-06-11 17:41:32
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import {Message} from 'element-ui';
import {saveAs} from 'file-saver';
import {getToken} from '@/utils/auth';
import errorCode from '@/utils/errorCode';
import {blobValidate} from '@/utils/ruoyi';

import config from '@/config'

const baseURL = config.apiHost

export default {
  name(name, isDelete = true){
    var url = baseURL + '/common/download?fileName=' + encodeURIComponent(name) + '&delete=' + isDelete;
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {Authorization: 'Bearer ' + getToken(), 'User-Type': '11'},
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data]);
        this.saveAs(blob, decodeURIComponent(res.headers['download-filename']));
      } else {
        this.printErrMsg(res.data);
      }
    });
  },
  resource(resource){
    var url = baseURL + '/common/download/resource?resource=' + encodeURIComponent(resource);
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {Authorization: 'Bearer ' + getToken()},
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data]);
        this.saveAs(blob, decodeURIComponent(res.headers['download-filename']));
      } else {
        this.printErrMsg(res.data);
      }
    });
  },
  zip(url, name){
    var url = baseURL + url;
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: {Authorization: 'Bearer ' + getToken()},
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data], {type: 'application/zip'});
        this.saveAs(blob, name);
      } else {
        this.printErrMsg(res.data);
      }
    });
  },
  saveAs(text, name, opts){
    saveAs(text, name, opts);
  },
  async printErrMsg(data){
    const resText = await data.text();
    const rspObj = JSON.parse(resText);
    const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default'];
    Message.error(errMsg);
  },
};
